module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-f3c72084.png";